module.exports = __webpack_public_path__ + "img/reports-active.163b22ed.svg";